import { FAServicesParams, FeatureAppMode } from "../types/service-configs";
import { FeatureAppNames } from "./app-constants";
import { isTruthy } from './is-truthy';

export interface ModelsCarouselIntegratorQueryParams {
  readonly carlineId?: string;
  readonly countryCode?: string;
  readonly currency?: string;
  readonly faServicesParams?: FAServicesParams;
  readonly faServicesUrl: string;
  readonly featureAppName: string;
  readonly galleryImages?: any;
  readonly galleryPath?: any;
  readonly graphQLServerUrl?: string;
  readonly language?: string;
  readonly mode?: string;
  readonly salesgroupId?: string;
  readonly showroomNodeId?: string;
  readonly ssr?: string;
  readonly trimName?: string;
}

export interface ModelsCarouselIntegratorOptions {
  readonly baseUrl?: string;
  readonly carlineId?: string;
  readonly countryCode: string;
  readonly currency: string;
  readonly faServicesParams?: FAServicesParams;
  readonly faServicesUrl: string;
  readonly featureAppName?: string;
  readonly galleryImages?: any;
  readonly galleryPath?: any;
  readonly graphQLServerUrl?: string;
  readonly language: string;
  readonly mode: FeatureAppMode;
  readonly salesgroupId?: string;
  readonly showroomNodeId?: string;
  readonly ssr?: boolean;
  readonly trimName?: string;
}

const getMode = (modeQueryParam: string | undefined): FeatureAppMode => {
  if (!modeQueryParam) return 'standalone';

  return modeQueryParam as FeatureAppMode;
};

export const getFeatureAppName = (
  featureAppName: string | undefined,
): string => {
  const featureAppNames: string[] = Object.values(FeatureAppNames);

  if (!featureAppName || !featureAppNames.includes(featureAppName)) return 'default';

  return featureAppName;
};

export const createOptionsFromQueryParams = (
  queryParams: ModelsCarouselIntegratorQueryParams,
): ModelsCarouselIntegratorOptions & any => {
  const credentials = {
    username: typeof process !== 'undefined' ? (process.env.CMS_USERNAME ?? '') : '',
    password: typeof process !== 'undefined' ? (process.env.CMS_PASSWORD ?? '') : '',
  };

  const {
    countryCode = 'US',
    currency = 'USD',
    language = 'en',
    faServicesUrl = 'https://qa.vwservicesfa.svc.vwusa.io',
    mode: modeQueryParam,
    featureAppName,
    ssr,
    faServicesParams = {
      urlOrigin: 'https://cs-int-vw-us.lighthouselabs.eu',
      urlPath: '/en.service-config.json',
      credentials,
    },
  } = queryParams;

  return {
    baseUrl: isTruthy(ssr) ? process.env.BASE_URL : '',
    countryCode,
    currency,
    faServicesParams,
    faServicesUrl,
    featureAppName: getFeatureAppName(featureAppName),
    language,
    mode: getMode(modeQueryParam),
    ssr: isTruthy(ssr),
  };
}